import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Chip, Typography } from '@mui/material';
import React from 'react';
import { useAlertUiTranslation } from '../../../../../hooks';
import { CollapsableSection } from './CollapsableSection';
export const AlertResponseOptions = ({ data }) => {
    const { t } = useAlertUiTranslation();
    if (data.responseOptions.length > 0) {
        return (React.createElement(CollapsableSection, { title: t('common.responseOptions'), header: React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1 } }, data.validityInHours != null && (React.createElement(Chip, { size: 'small', color: 'default', label: t('common.validityInHours', { count: data.validityInHours }) }))) },
            React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 1, backgroundColor: themeColors.surface.secondary } }, data.responseOptions.map((option) => (React.createElement(ResponseOptionBox, { key: option.optionId, option: option }))))));
    }
    else {
        return null;
    }
};
const ResponseOptionBox = ({ option }) => {
    const { t } = useAlertUiTranslation();
    let columns = 1;
    if (option.conferenceBridgeNumber) {
        ++columns;
    }
    if (option.conferenceBridgeMeetingId) {
        ++columns;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let gridTemplateColumns = (theme) => ({ xs: '100%' });
    if (columns === 2) {
        gridTemplateColumns = (theme) => ({ xs: `repeat(2, calc(50% - ${theme.spacing(1)}))` });
    }
    else if (columns === 3) {
        gridTemplateColumns = (theme) => ({ xs: `repeat(3, calc(33.333% - ${theme.spacing(4 / 3)}))` });
    }
    return (React.createElement(Box, { sx: { display: 'grid', gridTemplateColumns, gap: 2, p: 2, backgroundColor: themeColors.surface.tertiary, borderRadius: 1 } },
        React.createElement(Box, null,
            React.createElement(Typography, { variant: 'body2' }, t('common.responseOptionId', { id: option.optionId })),
            React.createElement(Typography, { variant: 'subtitle2' }, option.text)),
        option.conferenceBridgeNumber && (React.createElement(Box, null,
            React.createElement(Typography, { variant: 'body2' }, t('common.callBridgeNumber')),
            React.createElement(Typography, { variant: 'subtitle2' }, option.conferenceBridgeNumber))),
        option.conferenceBridgeMeetingId && (React.createElement(Box, null,
            React.createElement(Typography, { variant: 'body2' }, t('common.meetingId')),
            React.createElement(Typography, { variant: 'subtitle2' }, option.conferenceBridgeMeetingId)))));
};
